import {Component, ElementRef, OnInit, Renderer2} from '@angular/core';
import {Observable} from 'rxjs';
import {TransportationService} from '../../api/transportation.service';
import {ActivatedRoute, ParamMap, Router} from '@angular/router';
import {switchMap} from 'rxjs/operators';

@Component({
  selector: 'app-segment-content',
  templateUrl: './segment-content.component.html',
  styleUrls: ['./segment-content.component.scss']
})
export class SegmentContentComponent implements OnInit {

  constructor(private transportationService: TransportationService,
              private router: Router,
              private route: ActivatedRoute,
              private render: Renderer2,
              private elem: ElementRef) {
  }

  elementApplications$: Observable<any>;
  currentItem = null;


  ngOnInit() {

    this.elementApplications$ = this.route.paramMap.pipe(
      switchMap((params: ParamMap) =>
        this.transportationService.getTransportation(params.get('transport')))
    );


  }


  enteringZone(key) {
    this.elementApplications$.forEach(res => res.zones.forEach(result => {
      if (result.key === key) {
        this.currentItem = key;
      }
    }));
  }

  leavingZone(key) {
    this.currentItem = null;
  }



}
